import React, { useEffect, useState } from "react";
import Layout from "../components/Layout";
import Spinner from "react-bootstrap/Spinner";
import "../assets/styles/profile-page.css";
import theme from "../theme/theme";
import { useAuth } from "../auth/AuthContext";
import MySpinner from "../components/MySpinner";
import {
  getEmpProfile,
  getAllNationalityAsync,
  getQualificationAsync,
} from "../services/employeeService";
import EmpDisplayProfile from "../components/EmpDisplayProfile";
import EmpEditProfile from "../components/EmpEditProfile";


function ProfilePage() {
  const [employee, setEmployee] = useState([]);
  const [isEditing, setIsEditing] = useState(false);
  const [loading, setLoading] = useState(true);
  const [isFetched, setIsFetched] = useState(false);
  const [error, setError] = useState(false);
  const [showSpinner, setShowSpinner] = useState(false);
  const [qualifications, setQualifications] = useState([]);
  const [nationalities, setNationalities] = useState([]);
  const [isDropdownLoading, setIsDropdownLoading] = useState(false);
  const { userInfo } = useAuth();

  const [formData, setFormData] = useState({
    name:  "",
    qualificationId:  0 ,
    nationalityId:  0,
    phone:  "",
    email:  "",
    empNumber: "",
    idNumber:  "",
    hireDate: "",
    birthDate: "",
    gender:  "",

  });
  const loadEmployeeInfo = async () => {
    setLoading(true);
    setIsFetched(false);
    try {
      const empId =userInfo?.empId
      const data = await getEmpProfile(empId);
      setEmployee(data);
      setError(false);
    } catch (error) {
      setError(true);
    } finally {
      setLoading(false);
      setIsFetched(true);
    }
  };

  useEffect(() => {
     loadEmployeeInfo();
 
    }, []);

  
  const handleEdit = async () => {
    try {
      setIsDropdownLoading(true);
      const nationalityData = await getAllNationalityAsync();
      setNationalities(nationalityData);
      const qualificationData = await getQualificationAsync();
      setQualifications(qualificationData);
      setFormData({
        name: employee.name || "",
        qualificationId: employee.qualificationId   ,
        nationalityId: employee.nationalityId  ,
        phone: employee.phone || "",
        email: employee.email || "",
        empNumber:employee.empNumber || "",
        idNumber: employee.idNumber || "",
        hireDate:employee.hireDate || "",
        birthDate:employee.birthDate || "",
        gender: employee.gender || "",
          });
  
      setIsEditing(true); 
    } catch (error) {
      setError(true);
      alert("حدث خطأ اثناء جلب بعض البيانات ");
    } finally {
      setIsDropdownLoading(false);  
    }
  };

  const handlePhoneChange = (e) => {
    const phoneRaw = e.target.value;
    const digitsOnly = phoneRaw.replace(/\D/g, "");
    setFormData((prev) => ({
      ...prev,
      phone: digitsOnly,
    }));
  };
  
  const handlePhoneBlur = () => {
    const { phone } = formData;
    if (phone.length !== 10 || !phone.startsWith("05")) {
      setFormData((prev) => ({
        ...prev,
        phone: "",
      }));
    }
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevState) => ({
      ...prevState,
      [name]: name === "nationalityId" || name === "qualificationId" 
        ? parseInt(value, 10) || 0 
        : value,
    }));

  };


  if (loading) {
    return (
      <Layout>
        <MySpinner color={theme.colors.primary} />
      </Layout>
    );
  }

  if (isFetched && error) {
    return (
      <Layout>
        <div className="alert alert-danger">
          <p>عذرا حدث خطأ</p>
        </div>
      </Layout>
    );
  }

  return (
    <Layout>
      {loading && showSpinner && (
        <div className="d-flex flex-column align-items-center">
          <Spinner animation="border" role="status">
            <span className="sr-only">جار التحميل</span>
          </Spinner>
        </div>
      )}

{employee && (
  isEditing ? (
    isDropdownLoading ? (
      <MySpinner color={theme.colors.primary} />  
    ) :(
    <EmpEditProfile
      formData={formData}
      handlePhoneBlur={handlePhoneBlur}
      handlePhoneChange={handlePhoneChange}
      handleInputChange={handleInputChange}
       qualifications={qualifications}
      nationalities={nationalities}
      employee={employee} 
    />
    )
  ) : (
    <EmpDisplayProfile
     employee={employee}
      handleEdit={handleEdit}
      />
  )
)}
 

     
    </Layout>
  );
}

export default ProfilePage;
